import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
// axios
import axios from "axios";
import VueAxios from "vue-axios";
//swal
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
//session
import VueSession from "vue-session";

import Lightbox from "vue-easy-lightbox";
import VueApexCharts from "vue-apexcharts";
import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import VueCroppie from 'vue-croppie'
import 'croppie/croppie.css' // import the croppie css manually

Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);
Vue.use(VueSession);
Vue.use(VueSweetalert2);
Vue.use(VueAxios, axios);
Vue.use(Lightbox);
Vue.use(VueQuillEditor);
Vue.use(VueCroppie);

Vue.config.productionTip = false;
export const bus = new Vue();

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");

// require styles
require("./assets/css/main.css");
require("./assets/fonts/stylesheet.css");
